import { IScoreReference } from "../../../../common/types";
import { PlanActionTypes } from "../models/planActions";
import { ADD_NEW_SCORE } from "../types";

export default (data: IScoreReference): PlanActionTypes => ({
    type: ADD_NEW_SCORE,
    payload: data,
});
